export const BASE_URL = 'http://hoadon-api.binhtanwater.vn';

export const API_LOGIN = BASE_URL + '/auth/login';
